import React from 'react';
import { motion } from 'framer-motion';
export function OperatingModel() {
  const steps = [{
    title: 'Assess',
    desc: 'Identify strengths, gaps, and readiness barriers'
  }, {
    title: 'Explain',
    desc: 'Translate findings into clear, usable insight'
  }, {
    title: 'Recommend',
    desc: 'Provide practical next steps'
  }, {
    title: 'Support',
    desc: 'Connect to institutions, tools, and pathways'
  }, {
    title: 'Reassess',
    desc: 'Track growth over time'
  }, {
    title: 'Advance',
    desc: 'Unlock broader opportunity and responsibility'
  }];
  return <section className="py-20 bg-surface-bg border-y border-line overflow-hidden" data-id="element-1070" data-mp="18ezu07l65wb8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1071" data-mp="14f8unfhku7v3">
        <div className="mb-16" data-id="element-1072" data-mp="20xnb7bx1or71">
          <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-1073" data-mp="20yoj57irkxkj">
            Operating Model
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1074" data-mp="139o1sl0soqvg">
            From assessment to advancement
          </h2>
        </div>

        {/* Desktop Horizontal Flow */}
        <div className="hidden lg:block relative pt-8 pb-12" data-id="element-1075" data-mp="tkxqgijv7qjs">
          {/* Connecting Line */}
          <div className="absolute top-12 left-0 w-full h-px bg-line" data-id="element-1076" data-mp="yiz9j3hajpv9"></div>
          <div className="absolute top-12 left-0 w-full h-px bg-gradient-to-r from-navy via-teal to-green-soft opacity-30" data-id="element-1077" data-mp="yh4o7o23xvqn"></div>

          <div className="grid grid-cols-6 gap-4 relative" data-id="element-1078" data-mp="pjc9om47ms4b">
            {steps.map((step, index) => <motion.div key={step.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex flex-col items-center text-center group" data-id="element-1079" data-mp="ambqx83zy7hz" data-mpi={index}>
                {/* Node */}
                <div className="w-8 h-8 rounded-full bg-white border-2 border-navy z-10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-sm" data-id="element-1080" data-mp="1yk2p2nvol7s6">
                  <div className="w-2 h-2 rounded-full bg-teal" data-id="element-1081" data-mp="2r6x7zgcunz3j"></div>
                </div>

                <h3 className="text-lg font-heading font-bold text-ink-dark mb-2" data-id="element-1082" data-mp="2m8m03b647yny">
                  {step.title}
                </h3>
                <p className="text-sm text-ink-muted leading-relaxed px-2" data-id="element-1083" data-mp="2hgcdo547lgqf">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Mobile Vertical Flow */}
        <div className="lg:hidden relative pl-6 py-4 space-y-10" data-id="element-1084" data-mp="357rf7vo5vu0m">
          {/* Vertical Line */}
          <div className="absolute top-4 bottom-4 left-[15px] w-px bg-line" data-id="element-1085" data-mp="rp3n0vjfopxk"></div>

          {steps.map((step, index) => <motion.div key={step.title} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="relative pl-8" data-id="element-1086" data-mp="wnevb1u2ysdo" data-mpi={index}>
              {/* Node */}
              <div className="absolute left-[-17px] top-1 w-6 h-6 rounded-full bg-white border-2 border-navy z-10 flex items-center justify-center" data-id="element-1087" data-mp="1keu2b7wsxxv9">
                <div className="w-1.5 h-1.5 rounded-full bg-teal" data-id="element-1088" data-mp="1oh74jmccbdna"></div>
              </div>

              <h3 className="text-lg font-heading font-bold text-ink-dark mb-1" data-id="element-1089" data-mp="1tccssrt7t4ej">
                {step.title}
              </h3>
              <p className="text-sm text-ink-muted leading-relaxed" data-id="element-1090" data-mp="1kqjrpx9jb909">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}